import { Link } from 'react-router-dom';

import logoImg from '@/assets/logo.png';

interface LogoProps {
  className?: string;
  showText?: boolean;
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  ariaLabel?: string;
}

const logoWebpSrc = '/logo-header.webp';

const imageHeights: Record<NonNullable<LogoProps['size']>, number> = {
  sm: 28,
  md: 36,
  lg: 48,
};

const textSizeClasses: Record<NonNullable<LogoProps['size']>, string> = {
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-2xl',
};

const LogoContent = ({
  size,
  showText,
}: {
  size: NonNullable<LogoProps['size']>;
  showText: boolean;
}) => {
  return (
    <>
      <picture className="flex">
        <source srcSet={logoWebpSrc} type="image/webp" />
        <img
          src={logoImg}
          alt="Pedidoo"
          style={{ height: `${imageHeights[size]}px`, width: 'auto' }}
          className="object-contain"
          loading="lazy"
          decoding="async"
        />
      </picture>
      {showText && (
        <span className={`font-semibold text-slate-800 ${textSizeClasses[size]}`}>Pedidoo</span>
      )}
    </>
  );
};

export const Logo = ({
  className = '',
  showText = true,
  size = 'md',
  onClick,
  ariaLabel,
}: LogoProps) => {
  const label = ariaLabel ?? 'Pedidoo';

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        aria-label={label}
        className={`flex items-center gap-2 cursor-pointer rounded-md border-none bg-transparent p-0 ${className}`}
      >
        <LogoContent size={size} showText={showText} />
      </button>
    );
  }

  return (
    <Link to="/" aria-label={label} className={`flex items-center gap-2 ${className}`}>
      <LogoContent size={size} showText={showText} />
    </Link>
  );
};
